import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoryGrid from './components/CategoryGrid';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '红桃影院',
  url: 'https://www.hongtao.tv/',
  description: '红桃影院是您的首选在线影视平台，提供海量高清电影、电视剧、动漫等内容免费观看。',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://www.hongtao.tv/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function HomePage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <title>红桃影院 - 高清影视在线观看平台 | 免费电影电视剧动漫</title>
      <meta name="description" content="红桃影院是您的首选在线影视平台，提供海量高清电影、电视剧、动漫等内容免费观看。红桃影院汇聚全球热门影视资源，支持多端流畅播放，无广告打扰，随时随地畅享优质影视娱乐体验。" />
      <link rel="canonical" href="https://www.hongtao.tv/" />

      <main>
        <article>
          <HeroSection />
          <FeaturedSection />
          <CategoryGrid />
          <LatestSection />
          <FAQSection />
        </article>
      </main>
    </>
  );
}